export default __webpack_public_path__ + "static/media/025-buffalo.381c1d4b.svg";